var url = window['location']['href'];
var matches = url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
var domain = matches && matches[0];

export const environment = {
  production: true,
  apiURL: domain
};



// WEBPACK FOOTER //
// /opt/app/src/environments/environment.ts